import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=d8f502a2&"
import script from "./InfoButton.vue?vue&type=script&lang=ts&"
export * from "./InfoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports